// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1gu3d","title":"ClientInsurance_title__2BlHp","itemText":"ClientInsurance_itemText__3FTTX"};